import { render, staticRenderFns } from "./salary-send-dialog.vue?vue&type=template&id=43939780&scoped=true&"
import script from "./salary-send-dialog.vue?vue&type=script&lang=js&"
export * from "./salary-send-dialog.vue?vue&type=script&lang=js&"
import style0 from "./salary-send-dialog.vue?vue&type=style&index=0&id=43939780&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43939780",
  null
  
)

export default component.exports